import React from 'react'
import { useFormContext } from 'react-hook-form'
import { RadioButton } from '@/components/ui/ReactHookFormFields'
import { GRADES_COUNT } from './constants'
import { messages } from './messages'
import './styles.scss'

export const FinancingUxFeedbackModalFormGrade = () => {
  const { control } = useFormContext()

  return (
    <div className="financingUxFeedbackModalFormGrade">
      <div className="financingUxFeedbackModalFormGrade__heading">{messages.grade}</div>
      <div className="financingUxFeedbackModalFormGrade__radioButtons">
        {GRADES_COUNT.map(gradeCount => (
          <RadioButton
            key={gradeCount}
            control={control}
            value={String(gradeCount)}
            name="grade"
            className="financingUxFeedbackModalFormGrade__radioButton"
            checkmarkLabel={gradeCount}
          />
        ))}
      </div>
    </div>
  )
}
